export interface TenantBrand {
  id: string;
  brandName: string;
  logoUrl: string;
  logoIconUrl: string;
  faviconUrl: string;
  primaryColor: string;
  primaryHoverColor: string;
}

export const TENANT_BRANDS: Record<string, TenantBrand> = {
  default: {
    id: 'default',
    brandName: 'CreditPulse',
    logoUrl: 'https://media.creditpulse.com/branding/credit-pulse-banner-logo-transparent.png',
    logoIconUrl: 'https://media.creditpulse.com/branding/credit-pulse-icon-transparent.png',
    faviconUrl: 'https://media.creditpulse.com/branding/favicon.ico',
    primaryColor: '#565BDF',
    primaryHoverColor: '#2125AB',
  },
  handle: {
    id: 'handle',
    brandName: 'Handle',
    logoUrl: 'https://media.creditpulse.com/branding/handle/handle-banner-logo.png',
    logoIconUrl: 'https://media.creditpulse.com/branding/handle/handle-icon-logo.png',
    faviconUrl: 'https://media.creditpulse.com/branding/handle/handle-favicon.ico',
    primaryColor: '#446fda',
    primaryHoverColor: '#2164f1',
  },
};

export const SUBDOMAIN_TO_BRAND: Record<string, string> = {
  app: 'default',
  handle: 'handle',
};

export const resolveSubdomainTenant = (hostname?: string): TenantBrand => {
  const targetHostname = hostname ?? (typeof window !== 'undefined' ? window.location.hostname : '');

  if (!targetHostname) {
    return TENANT_BRANDS.default;
  }

  const subdomain = targetHostname.split('.')[0];
  const brandKey = SUBDOMAIN_TO_BRAND[subdomain];

  if (brandKey && TENANT_BRANDS[brandKey]) {
    return TENANT_BRANDS[brandKey];
  }

  return TENANT_BRANDS.default;
};
